import { Component } from '@angular/core';



@Component({
    selector: 'app-banner-demo',
    templateUrl: './banner-demo.component.html',
    styleUrls: ['./banner-demo.component.scss'],
    standalone: false
})
export class BannerDemoComponent {

}
